import { http } from "Utils/http";
import { httpDownload } from "Utils/httpDownload";
import { STATUSES } from "Utils/constants";

export const VB_DETAIL_URL = "/api/psoDir/getBatchDetail";
export const VB_NEW_PSO_URL = "/api/psoDir/listNewPso";
export const VB_DELISTED_PSO_URL = "/api/psoDir/listDelistedPso";
export const VB_SUBMIT_DELISTED_URL = "/api/psoDir/delistPso";

const rejectIfPayloadError = (payload) => {
  return (payload?.status !== 1 || (payload?.globalErrorMessageList?.length > 0));
};

export const getBatchDetail = async (token, batchId) => {
  let status = STATUSES.SUCCESS;
  return http.post(VB_DETAIL_URL, { batchId }, { headers: { Authorization: token } })
    .then((res) => {
      if (rejectIfPayloadError(res)) {
        status = STATUSES.ERROR;
        return Promise.reject({ status, data: res });
      }
      return Promise.resolve({ status, data: res });
    })
    .catch((error) => {
      status = STATUSES.ERROR;
      return Promise.reject({ status, data: error });
    });
};

export const getNewPSOList = async (token, filter, batchId) => {
  let status = STATUSES.SUCCESS;
  const body = { pageReq: {...filter}, batchId: batchId };
  return http.post(VB_NEW_PSO_URL, body, { headers: { Authorization: token } })
    .then((res) => {
      if (rejectIfPayloadError(res)) {
        status = STATUSES.ERROR;
        return Promise.reject({ status, data: res });
      }
      return Promise.resolve(res);
    })
    .catch((error) => {
      status = STATUSES.ERROR;
      return Promise.reject({ status, data: error });
    });
};

export const getDelistedPSOList = async (token, filter, batchId) => {
  let status = STATUSES.SUCCESS;
  const body = { pageReq: {...filter}, batchId: batchId };
  return http.post(VB_DELISTED_PSO_URL, body, { headers: { Authorization: token } })
    .then((res) => {
      if (rejectIfPayloadError(res)) {
        status = STATUSES.ERROR;
        return Promise.reject({ status, data: res });
      }
      return Promise.resolve(res);
    })
    .catch((error) => {
      status = STATUSES.ERROR;
      return Promise.reject({ status, data: error });
    });
};

export const submitDelistedPSO = async (token, body) => {
  let status = STATUSES.SUCCESS;
  return http.post(VB_SUBMIT_DELISTED_URL, body, { headers: { Authorization: token } })
    .then((res) => {
      const payload = res?.data ?? res;
      if (rejectIfPayloadError(payload)) {
        status = STATUSES.ERROR;
        return Promise.reject({ status, data: payload });
      }
      return Promise.resolve({ status, data: payload });
    })
    .catch((error) => {
      status = STATUSES.ERROR;
      return Promise.reject({ status, data: error });
    });
};
